/**
 * Month name <-> integer bridge (spec 0018, increment B).
 *
 * The reused `InputYearMonth` picker stores a month as a localised NAME string,
 * but the new career API uses integer `startMonth`/`endMonth` (1-12). The profile
 * date pickers are driven in English so the stored value is always an English
 * month name and the mapping is deterministic; the reverse lookup also accepts
 * Russian names defensively.
 */
const EN_MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const RU_MONTHS = [
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];

/** Localised month name -> 1-12, or null when empty/unknown. */
export const monthNameToNumber = (name: string): number | null => {
  if (!name) {
    return null;
  }
  const idx = EN_MONTHS.indexOf(name);
  if (idx >= 0) {
    return idx + 1;
  }
  const ruIdx = RU_MONTHS.indexOf(name);
  return ruIdx >= 0 ? ruIdx + 1 : null;
};

/** 1-12 -> English month name (the picker language), or '' when empty. */
export const monthNumberToName = (month?: number | null): string =>
  month && month >= 1 && month <= 12 ? EN_MONTHS[month - 1] : '';

/** '2019' -> 2019, '' -> null. */
export const yearToNumber = (year: string): number | null => {
  const parsed = parseInt(year, 10);
  return Number.isNaN(parsed) ? null : parsed;
};

/** 2019 -> '2019', null -> ''. */
export const yearToString = (year?: number | null): string =>
  year === null || year === undefined ? '' : `${year}`;
